import { TooltipProps } from "recharts";
import { ValueType, NameType } from "recharts/types/component/DefaultTooltipContent";
import { ImageService } from "../../../../services/image/imageService";
import { WeatherState } from "./WeatherUtils";
import styled from "styled-components";

const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>): JSX.Element => {
    
    console.log(payload)
    if (active) {
        return (
            <Container>
                <div style={{"fontWeight": "bold"}}>{`Heure: ${label}`}</div>
                <div>{`Température: ${payload?.[0].value} °C`}</div>
            </Container>
        );
    }

    return <></>;
}

const Container = styled.div`
    background-color: white;
    border: solid black 2px;
    border-radius: 5px;
    padding: .5em;
`

export default CustomTooltip;